import { useState } from "react";
/* Styles */
import './toggleSwitch2.css';

const ToggleSwitch2 = ({ onChange, trueLabel , falseLabel }) => {
  const [toggle, setToggle] = useState(false);
  const toggleClass = 'toggle-active';
  const onToogle = () => {
    onChange(!toggle)
    setToggle(!toggle);
  }

  return (
    <div
      className={`toggle-switch2 ${toggle ? 'no' : 'si'}`}
      onClick={onToogle}
    >
      <div className={`toggle-inner ${toggle ? null : toggleClass}`}></div>
    </div>
  );
}

export default ToggleSwitch2;